// extracted by mini-css-extract-plugin
export default {"cls1":"EzPGNqQ9WDpEoF8Xbwov","cls2":"gwG2x_Z2nyd9liGSZZsU EzPGNqQ9WDpEoF8Xbwov"};